import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { RevoGridModule } from '@d.ratzinger/angular-datagrid';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgJsonEditorModule } from 'ang-jsoneditor';

import { FormOptionComponent } from './form/form.component';
import { SharedComponent } from './shared.component';
import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';
import { UserActivityPopupComponent } from 'src/app/shared/user-activity-popup/user-activity-popup.component';

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

const COMMON_MODULES = [
    CommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ToastrModule,
    RevoGridModule,
    NgSelectModule,
    NgMultiSelectDropDownModule,
    NgJsonEditorModule
];

const COMPONENT = [
    FormOptionComponent,
    SharedComponent,
    PageNotFoundComponent,
    UserActivityPopupComponent
];


@NgModule({
    declarations: [
        ...COMPONENT
    ],
    imports: [
        ...COMMON_MODULES
    ],
    exports: [
        ...COMMON_MODULES, ...COMPONENT
    ],
    providers: []
})
export class SharedModule {
}
